import { AskResponse, Citation } from "../../api";
import { cloneDeep } from "lodash-es";

type ParsedAnswer = {
  citations: Citation[];
  markdownFormatText: string;
};

let filteredCitations = [] as Citation[];

// Find an existing citation that matches (same chunk or same document section)
const findMatchingCitation = (citation: Citation): Citation | undefined => {
  return filteredCitations.find((c) => {
    // Same chunk ID (exact same chunk referenced again)
    if (c.id === citation.id) return true;
    // Same display title = same document section (different chunks, same content)
    if (c.title && citation.title && c.title === citation.title) return true;
    return false;
  });
};

export function parseAnswer(answer: AskResponse): ParsedAnswer {
  let answerText = answer.answer;
  const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g);

  const lengthDocN = "[doc".length;

  filteredCitations = [] as Citation[];
  let citationReindex = 0;
  citationLinks?.forEach((link) => {
    // Replacing the links/citations with number
    let citationIndex = link.slice(lengthDocN, link.length - 1);
    let citation = cloneDeep(
      answer.citations[Number(citationIndex) - 1],
    ) as Citation;
    if (citation === undefined) return;

    const existing = findMatchingCitation(citation);
    if (!existing) {
      answerText = answerText.replaceAll(link, ` ^${++citationReindex}^ `);
      citation.reindex_id = citationReindex.toString();
      filteredCitations.push(citation);
    } else {
      // Reuse the existing citation's index for this duplicate
      answerText = answerText.replaceAll(link, ` ^${existing.reindex_id}^ `);
    }
  });

  return {
    citations: filteredCitations,
    markdownFormatText: answerText,
  };
}
